import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';

export const HowDoesCreatePolicyWork: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Findings', field: 'findings' },
    { label: 'Issues', field: 'issues' },
    { label: 'Remediation', field: 'remediation' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="create_policy"
      headerTitle="Policy Creation"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Ariksa provides a robust and flexible policy framework to support
              custom policies and insights that important for your organization.
              These are in addition to the hundreds of policies out of the box
              that we provide to automate and accelerate detection of threats
              and risks to your cloud environment.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Policy Generation</Text>
            <Text>
              To generate a policy, provide a description of the scenario that
              you want to create a policy for. Ariksa AI is built to understand
              cloud security, commonly used terminology and organizational
              context and automatically generate a policy that you can add to a
              custom policy blueprint for automatic detection. If the policy
              does not match your requirement, you can retry. If the generated
              policy is accurate and meets your needs, you can save it after
              choosing its category and severity.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
